/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Login_Title_AccentInputs */

const en_auth_login_title_accent = /** @type {(inputs: Auth_Login_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`back.`)
};

const pl_auth_login_title_accent = /** @type {(inputs: Auth_Login_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`powrotem.`)
};

/**
* | output |
* | --- |
* | "back." |
*
* @param {Auth_Login_Title_AccentInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const auth_login_title_accent = /** @type {((inputs?: Auth_Login_Title_AccentInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Login_Title_AccentInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_auth_login_title_accent(inputs)
	return en_auth_login_title_accent(inputs)
});